export type Unpacked<T> = T extends ReadonlyArray<infer U> ? U : T;

export type AtLeastOne<T, U = { [K in keyof T]: Pick<T, K> }> = Partial<T> &
  U[keyof U];

export type ExcludeEmpty<T> = T extends AtLeastOne<T> ? T : never;

/**
 * Extracts a type from a union that matches the given type
 *
 * Helpful for filtering out types from a union that match a certain type
 *
 * Example:
 * type Item = { name: string } | { age: number } | { id: string };
 * type ExtractedType = ExtractType<Item, { name: string }>; // { name: string }
 */
export type ExtractType<T, U> = T extends U ? T : never;

export function notEmpty<TValue>(
  value: TValue | null | undefined,
): value is TValue {
  return value !== null && value !== undefined;
}

export function notEmptyObject<TValue extends {}>(
  value: TValue | null | undefined,
): value is ExcludeEmpty<TValue> {
  return notEmpty(value) && Object.keys(value).length > 0;
}
